import { injectable, inject } from 'inversify';
import type { CollectionsReportDTO, IReportRepository } from '@/domain/repositories/IReportRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class GetCollectionsReportAction {
  constructor(
    @inject(TYPES.IReportRepository) private reportRepository: IReportRepository
  ) {}

  async execute(): Promise<CollectionsReportDTO> {
    return this.reportRepository.getCollectionsReport();
  }
}
